import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";


const RenderWptcardphoto = () => {


const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const AD_USER=sessionStorage.getItem("AD_USER");

const navigate = useNavigate();


const [dowait, setDowait] = useState({show: false});
const [tblwptcardphoto, setTblwptcardphoto] = useState([]);

const [axiofl, setAxiofl] = useState({selectedFile: null});



const [progress, setProgress] = useState({
perct:null
});


const [wptapp, setWptapp] = useState({WPT_APP_ID:0});
const [uploadfile, setUploadfile] = useState({name:"", RELATION:"" });


const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "Work Permit Card Photos";	

if (location.state)
	if (location.state.wptapp)
		setWptapp(location.state.wptapp);

 },[]);




useEffect(() => {
	
	const WPT_APP_ID=wptapp.WPT_APP_ID??0;
	
	if (WPT_APP_ID>0)
		gettblwptcardphoto();

 },[wptapp.WPT_APP_ID]);


/*
useEffect(() => {
	
	console.log("uploadfile.openfilebrowser: "+uploadfile.openfilebrowser);
	
	if (uploadfile.openfilebrowser==true)
		document.getElementById('imagefileinput').click();


setUploadfile((prev)=>{
	return openfilebrowser:false;
	});

 },[uploadfile.openfilebrowser]);
*/


useEffect(() => {
	
	if (axiofl.selectedFile==null)
		return;
	

	cssclass("btnuploadfile", "hidden", 0);
		

 },[ axiofl.selectedFile]);





async function gettblwptcardphoto(){

const params={
	//--TEST WITH CFC01kr 15584
	WPT_APP_ID: wptapp.WPT_APP_ID
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/gettblwptcardphoto',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptcardphoto(res) )
      .catch(err => console.log(err));

}//end func

function aftergettblwptcardphoto(res){

if (!res.length)
	return;

let htmrows=[];
	
res.map((col, index) => {
	
	const key="tblphoto_"+index;
	
	const WORK_PERMIT_ID=col['WORK_PERMIT_ID']??"";
	const FULLNAME=col['FULLNAME']??"";
	
	console.log("FULLNAME: '"+FULLNAME+"' ");
	
	var RELATION=col['RELATION']??"";
	if (RELATION=="Applicant")
		RELATION="";
	else
		RELATION=RELATION.replace(" ","");
	
	const appWORK_PERMIT_ID = wptapp.WORK_PERMIT_ID??0;
	//const appWORK_PERMIT_ID = 336227;
	
	
	if (FULLNAME!=""){
		
		const HEAD_FILE_SIZE = setWptapp.HEAD_FILE_SIZE??0;
		if (col['RELATION']=="Applicant" && col['HEAD_FILE_SIZE']>0 && HEAD_FILE_SIZE==0)
			setWptapp((prev)=>{
				return {...prev, HEAD_FILE_SIZE:col['HEAD_FILE_SIZE']}
				});
			
		
		const htmrow=<tr key={key} valign="bottom" >
			<td align="right" >{index+1}</td>
			<td align="left" >
				{col['RELATION']}
				</td>
			<td align="left" >
				<table align="left" style={{marginLeft:"12px"}} >
				<tbody>
				<tr>
					<td align="left" >
					<div className='tooltip' ><a href="#" className="nodecor" id="linkpreviewcard"  onClick={(e)=>{ rptcardphoto(e, WORK_PERMIT_ID, wptapp.WPT_APP_ID, col['RELATION'], FULLNAME); }}  title="preview work permit card" ><img src="img/plasticcard.png" border="0" />&nbsp;{FULLNAME}</a><span className='tooltiptext'>preview work permit card</span></div>
					</td>
				</tr>
				<tr><td align="left" >Headshot Size & Stamp: {col['HEAD_FILE_SIZE']} KB {col['IMGS_SENT_PREM']}</td></tr>
				<tr><td align="left" >Signature Size &  Length: {col['SIGN_FILE_SIZE']} KB {col['SIGNAT_LENGTH']}</td></tr>
				</tbody>
				</table>
			</td>
			<td align="center" style={{paddingTop:"12px"}} ><img id={"foto_"+index} src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/"+RELATION+"foto.png&stamp="+Math.random()} border='0' height="80" />&nbsp;&nbsp;<div className='tooltip' ><a href="#" onClick={(e)=>{ clickimage(e, "foto.png", RELATION); }} ><img src="img/fileuplpad.png" /></a><span className='tooltiptext'>click to browse for image</span></div></td>
			<td align="center" style={{paddingTop:"12px"}} ><img id={"thum_"+index} src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/"+RELATION+"thumb.png&stamp="+Math.random()} border='0' height="50" /></td>
			<td align="center" style={{paddingTop:"12px"}} ><img id={"sign_"+index} src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/"+RELATION+"signat.png&stamp="+Math.random()} border='0' height="50" />&nbsp;&nbsp;<div className='tooltip' ><a href="#" onClick={(e)=>{ clickimage(e, "signat.png", RELATION); }} ><img src="img/fileuplpad.png" /></a><span className='tooltiptext'>click to browse for image</span></div></td>
			</tr>;
			
			{/*
			<td align="right" >{col['FILE_SIZE']}</td>
			<td align="center" >{col['STAMP']}</td>				
			*/}				
					
		htmrows.push(htmrow);
		}//end if
	
	});//end map	

setTblwptcardphoto(htmrows);
}//end func




async function rptcardphoto(e, WORK_PERMIT_ID, WPT_APP_ID, RELATION, fullName){

e.preventDefault();
cssclass("btnuploadfile", "hidden", 1);
	
RELATION=RELATION.replace(" ","")	;

//if theres no WORK_PERMIT_ID then pass WPT_APP_ID and RELATION
//ODALIS SOSA DOLORE
const tempName=fullName.length>18?fullName.substring(0,18):fullName;
const resFilePath="C:\\scripts\\ireports\\out\\Card Preview "+tempName+".pdf";
//2026 08 23 Azure was blocking and got it fixed in PostMan by changing && to &
const paramsurl="reportfilepath=C:\\scripts\\ireports\\wpcard.jasper"+
				"&resultfilepath="+resFilePath+
				"&lsargs=WPT_APP_ID,RELATION"+
				"&lsvals="+WPT_APP_ID+","+RELATION;
				//note: lsvals and lsargs are comma separated values lists

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {paramsurl:paramsurl} )
  };		

cssclass(e.target.id, "hidden", 1);

 await fetch(resturl+'rarwpform/jaspertopdf',requestOptions)
		.then(res => res.json())
      .then(res => 	afterrptcardphoto(res, e, fullName) )
      .catch(err => console.log(err));

/*
  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
      .then(res => 	aftergetlbrclrLetter(res, e, decsnKey.LBR_CLR_APP_ID) )
      .catch(err => console.log(err));

*/
	  
}//end func

async function afterrptcardphoto(res, e, fullName){

cssclass(e.target.id, "hidden", 0);
//if (e.target.classList.contains("hidden"))
	//e.target.classList.remove("hidden");


//const url=resturl+"rarwpform/getwptapppdfdoc?mpename="+mpename+"&filename="+filename+"&refnum="+wptapp.REF_NUM;
//console.log("url: "+url);
const strFile=res.length?(res[0].File??""):"";
if (strFile=="")
	window.alert("No File was returned.  Try upload the headshot and signature image files first");
else{
	window.scrollTo(0, 0);
	document.getElementById("embed1").src = base64ToURL(strFile);
	cssclass("divvideo", "displaynone", 1);
	cssclass("divpdf", "hidden", 0);
	const rect = document.getElementById("embed1").getBoundingClientRect();
	window.scrollTo(0, rect.top);
	}//end else
	

}//end func	



    function base64ToURL(base64) {
            var jsonData = {
                "baseFile": base64
            };

        // Extract the Base64 data from the JSON object
        var base64Data = jsonData.baseFile;

        // Decode the Base64 data to binary
        var binaryData = atob(base64Data);

        // Create a Uint8Array from the binary data
        var uint8Array = new Uint8Array(binaryData.length);
        for (var i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        // Create a Blob from the Uint8Array
        var blob = new Blob([uint8Array], { type: 'application/pdf' });

        // Create an object URL for the blob
        var objectURL = URL.createObjectURL(blob);

        // Display the PDF using <embed> or <iframe>
		return objectURL;

    };



function clickimage(e, fileName, RELATION){
e.preventDefault(); 
//setUploadfile({name:"", RELATION:""}); 
setUploadfile({name:fileName, RELATION:RELATION});
//, openfilebrowser:true
document.getElementById('imagefileinput').click();
}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func




function selectedFilesChange(e){
	
	console.log("selectedFilesChange");
	
	if (e)
		e.preventDefault();
	const filename='foto.png';
//console.log('selectedFilesChange index: '+index);

if (e.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (e.target.files.length==0)
	return;
	
	
	
const fileName=e.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="png, jpg, jpeg, bmp, webp, gif";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	//document.getElementById("imagefileinput").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if		


if (e.target.files.length==1){
	setAxiofl({ selectedFile: e.target.files[0] });
	}//end if


//the below flags to add the button in DOM
setWptapp((prev)=>{
	return {...prev, HEAD_FILE_SIZE:0}
	});

}//end func


async function uploadwpcardfoto(){
	console.log('uploadwpcardfoto: '+axiofl.selectedFile.name);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 1 
router.post('/uploadfiles', upload.array('filesupload',1), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

var fileExtension = "";
const fileName=axiofl.selectedFile.name;
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

form.append('REF_NUM', wptapp.REF_NUM);
//form.append('FILE_NAME_ONLY', uploadfile.name.replace(".png", ""));
//form.append('RELATION', uploadfile.RELATION);
form.append('FILE_SIZE', axiofl.selectedFile.size);
form.append('FOTO_EXT', fileExtension);
form.append('WPT_APP_ID', wptapp.WPT_APP_ID);
form.append('WORK_PERMIT_ID', wptapp.WORK_PERMIT_ID??"0");
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
//let formfiles={foto:false,sign:false,scans:false};
//let filenames={foto:''};
form.append('RES_FILE_NAME', uploadfile.name);
form.append('MAKE_THUMBNAIL', uploadfile.name=="foto.png"?1:0);
form.append('RELATION', uploadfile.RELATION);
const newFileObj=new File([axiofl.selectedFile], uploadfile.RELATION+(uploadfile.name.replace(".png","_orig.png")));
form.append('ORIG_FILE_NAME', newFileObj.name);
//form.append('RES_FILE_NAME', newFileObj.name.replace("_orig.png",".png"));
//form.append('FOTO_EXT', selectedFiles[i].ext);
if (newFileObj==null){
	window.alert("file upload failed");
	return;
	}
form.append('filesupload', newFileObj);

	const request_config = {
		onUploadProgress: data => {
		  //Set the progress value to show the progress bard
		  setProgress({perct:Math.round((100 * data.loaded) / data.total)});
		},
	};
	setDowait({show:true});
	
/*
	for (var i=0; i<5; i++){
		if (document.getElementById("foto_"+i))	
			document.getElementById("foto_"+i).src=null;
		if (document.getElementById("thum_"+i))	
			document.getElementById("thum_"+i).src=null;
		if (document.getElementById("sign_"+i))	
			document.getElementById("sign_"+i).src=null;
		}//end for
	
	setTblwptcardphoto([]);

*/	

	cssclass("btnuploadfile", "hidden", 1);
		


	await axios.post(resturl+'rarscans/uploadwpcardfoto', form, request_config)
	.then(res => afteruploadwpcardfoto(res.data));
	
	


{/*
	function cb(res){
		console.log('cb: '+JSON.stringify(cb));
	}

*/}

	
}//end func

function afteruploadwpcardfoto(data){
	console.log('afteruploadwpcardfoto: '+JSON.stringify(data));

const filesize=data.filesize??0;
if (filesize==0)
	window.alert("Something went wrong");
else{
	showsnackbar("Done!");
	setDowait({show:false});
	}

gettblwptcardphoto();		

}//end func









const returnPg=(wptapp.PROCESS_AREA??"")=="Government"?"gvtform":"wptform";	
const WORK_PERMIT_ID=wptapp.WORK_PERMIT_ID??0;

return (
<>
<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"20px"}} >Headshot and Signature Photos for this Application {wptapp.REF_NUM}</p>

<table align="center" border="0" width="80%" >
	<tbody>
	<tr>
		<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/"+returnPg, {state:{WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:"J"}});  }}  ><img src="img/return.png" border="0" /> return to application</a></td>
		<td align="left" >
		The photos uploaded here can help with printing work permit cards.{WORK_PERMIT_ID>0 && <span>&nbsp;&nbsp;Work Permit Id # {WORK_PERMIT_ID}</span> }
		<br/>click the up arrow to browse for photo.  Accepted file formats: png, jpg, jpeg, bmp, webp, gif	
		{/*
		If the application is not a renewal, consider waiting until labour clearance is approved
		<br/>before uploading imagefileinputure photo.  imagefileinputure photo is used when printing the work permit card

		*/}
		</td>
		<td align="center" >
			{wptapp.HEAD_FILE_SIZE==0 && <button id="btnuploadfile" onClick={(e)=>{ uploadwpcardfoto(); }}  className="button hidden" >upload image file</button>}
			{wptapp.HEAD_FILE_SIZE>0 && wptapp.STATUS=="NOTSUBMIT" && <button id="btnproceed" onClick={(e)=>{ navigate("/submitwpform", {state:{wptapp:wptapp}}); }}  className="button" >submit application</button>}
			
		</td>
	</tr>
	
	</tbody>
	</table>



<table align="center" border="1" width="92%" style={{borderCollapse:"collapse"}} >
	<thead>
	<tr>
		<th align="right" >#&nbsp;&nbsp;</th>
		<th align="left" >&nbsp;&nbsp;Relation</th>
		<th align="left" >&nbsp;&nbsp;Person's Name</th>
		<th align="center" >Cropped Headshot</th>
		<th align="center" >Thumb File</th>
		<th align="center" >Signature (<span style={{color:"brown"}}>NOT MANDATORY</span>)</th>
	</tr>
	</thead>

	<tbody>
	{tblwptcardphoto}
	</tbody>

</table>



<p></p>
 
 {/*lVGDw6lxE5A transparent */}
		<div align="center" width="100%" id="divvideo"  style={{backgroundColor:"transparent"}} >
		
		<iframe  height="400" width="700"
			src="https://www.youtube.com/embed/lVGDw6lxE5A">
		</iframe>
		</div>

		<div align="center" id="divpdf" className="hidden"  >
		You can preview the Work Permit Card to see if the information and photos are correct
		<embed id="embed1"
			/*src="https://customsprem.gov.tc/webuploads/currdoc/Notice%20Of%20Auction%20-%20Providenciales%20Auction%20List%202021.pdf#toolbar=0&navpanes=0&scrollbar=0"*/
			src=""
			type="application/pdf"
			frameBorder="0"
			scrolling="auto"
			height="800"
			width="95%"
			
		></embed>
		
		</div>



	

		
		{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
		{!dowait.show && 
			<table align="center" >
			<tbody>
			
			</tbody>
			</table>
		}


<input type='file' id='imagefileinput' className="hidden" accept=".png,.jpg,.jpeg,.bmp,.webp,.gif"  onChange={(e)=>{selectedFilesChange(e);}} />


{/*
		<th align="left" >Date</th>
		<th align="left" >Size</th>

*/}

<div id="snackbar">&nbsp;</div>

    </>
  );
  


};


export default RenderWptcardphoto;